import { useRef, useState } from "react";
import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import styles from "./index.module.scss";
import SubscriptionsTable from "./subscriptions-table";
import { plansData } from "./subscriptions-table/mock.data";
import BannerInfo from "./banner-info";
import ContractSettingsTable from "./contract-settings-table";

const SubscriptionsPage = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <SearchFilterComponent
          leftSide={
            <div>
              <span className={styles.title}>
                Available Subscriptions
              </span>
            </div>
          }
          searchValue={searchValue}
          searchOnChange={handleSearchOnChange}
          searchOnCross={handleSearchOnCross}
          passedRef={searchInputRef}
          setRef={() => {
            searchInputRef.current?.focus();
          }}
          lastButtonLabel="Add"
        />
        <div className={styles.content}>
          <SubscriptionsTable plansData={plansData} />
          <div className="d-flex justify-content-end">
            <BannerInfo />
          </div>
        </div>
        <h2 className="m-0 f-16 line-height-24 f-600 f-black">
          Default Contract Settings
        </h2>
        <ContractSettingsTable />
      </div>
    </div>
  );
};

export default SubscriptionsPage;
